import gql from "graphql-tag";

const COMMON_QUERY = `
id
name
createdAt
updatedAt
`;

const EXPAND_QUERY = `
categories {
  id
  title
  code
}
`;

const createHelpdeskCategoryGroup = gql`
  mutation(
    $name: String!
  ) {
    createHelpdeskCategoryGroup(
      data: {
        name: $name
      }
    ) {
      ${COMMON_QUERY}
    }
  }
`;

const updateHelpdeskCategoryGroup = gql`
  mutation(
    $id: ID!
    $name: String
  ) {
    updateHelpdeskCategoryGroup(
      id: $id
      data: {
        name: $name
      }
    ) {
      ${COMMON_QUERY}
    }
  }
`;

const deleteHelpdeskCategoryGroup = gql`
  mutation($id: ID!) {
    deleteHelpdeskCategoryGroup(id: $id) {
      id
    }
  }
`;

const getAllHelpdeskCategoryGroup = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
  ) {
    getAllHelpdeskCategoryGroup(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      ${COMMON_QUERY}
      ${EXPAND_QUERY}
    }
  }
`;

const getHelpdeskCategoryGroup = gql`
  query($id: ID!) {
    getHelpdeskCategoryGroup(id: $id) {
      ${COMMON_QUERY}
      ${EXPAND_QUERY}
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createHelpdeskCategoryGroup,
  updateHelpdeskCategoryGroup,
  deleteHelpdeskCategoryGroup,
  getAllHelpdeskCategoryGroup,
  getHelpdeskCategoryGroup,
};
